import React from 'react'
import PropTypes from "prop-types";
import { Typography } from 'antd'
import { useTranslation } from 'react-i18next';


const NoDataText = (props) => {
    const { message } = props;
    const { t } = useTranslation();
    return (
        <Typography.Text strong type='secondary'>{t(message)}</Typography.Text>
    )
}

export default NoDataText

NoDataText.defaultProps = {
    message: "No data",
};

NoDataText.propTypes = {
    message: PropTypes.string,
};